import React, { type FC } from 'react'

import type { ReadonlyRecord } from '../../../../utils'

import { StatusType } from '../../../../domain'

import { Chip, type ChipProps } from '../Chip'
import { StatusDot } from './Dot'
import { useStatusTranslator } from './Hooks'

type StatusVariant = Extract<ChipProps['variant'], 'success' | 'warning' | 'danger' | 'grey'>

const variants: ReadonlyRecord<StatusType, StatusVariant> = {
    [StatusType.DEAD]: 'danger',
    [StatusType.DISCONNECTED]: 'danger',
    [StatusType.EXITED]: 'danger',
    [StatusType.INVALID]: 'danger',
    [StatusType.OFFLINE]: 'danger',
    [StatusType.UNAVAILABLE]: 'danger',
    [StatusType.UNEXPECTED]: 'danger',
    [StatusType.UNREACHABLE]: 'danger',

    [StatusType.CONNECTING]: 'warning',
    [StatusType.DEVIATED]: 'warning',
    [StatusType.DISABLING]: 'warning',
    [StatusType.DISCONNECTING]: 'warning',
    [StatusType.ENABLING]: 'warning',
    [StatusType.RECONNECTING]: 'warning',
    [StatusType.REENABLING]: 'warning',
    [StatusType.RESTARTING]: 'warning',
    [StatusType.ROLLING_BACK]: 'warning',
    [StatusType.STARTING]: 'warning',
    [StatusType.STOPPING]: 'warning',
    [StatusType.UPDATING]: 'warning',

    [StatusType.ACTIVE]: 'success',
    [StatusType.AVAILABLE]: 'success',
    [StatusType.CONNECTED]: 'success',
    [StatusType.ENABLED]: 'success',
    [StatusType.NO_DEVIATION]: 'success',
    [StatusType.ONLINE]: 'success',
    [StatusType.REACHABLE]: 'success',
    [StatusType.RUNNING]: 'success',
    [StatusType.VALID]: 'success',

    [StatusType.CREATED]: 'grey',
    [StatusType.DISABLED]: 'grey',
    [StatusType.INACTIVE]: 'grey',
    [StatusType.NOT_ENABLED]: 'grey',
    [StatusType.PAUSED]: 'grey',
    [StatusType.TERMINATED]: 'grey',
    [StatusType.UNKNOWN]: 'grey',
    [StatusType.WAITING]: 'grey',
}

const Status: FC<Readonly<{ status: StatusType }>> = ({ status, ...props }) => {
    const translateStatus = useStatusTranslator()

    return <Chip {...props} variant={variants[status]} size="medium" icon={<StatusDot />} label={translateStatus(status)} />
}

export default Status
